export const invoiceIntervals = [1, 2, 3, 4, 6, 12, 24, 36, 60];
export const paymentTerms = [14, 21, 30, 36, 45, 60, 75, 90];
